export default "__VITE_ASSET__CKfK4a1v__"